import * as before from './before'
import * as after from './after'

export function register(router) {
  before.register(router)
  after.register(router)
}
